
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShoppingBag, Plus, Package, CreditCard, TrendingUp, Star } from "lucide-react";

const VenueEcommerce = () => {
  const products = [
    {
      id: 1,
      name: "Club Babylon VIP Table",
      price: 2500,
      category: "VIP Package",
      sold: 15,
      rating: 4.8,
      status: "active"
    },
    {
      id: 2,
      name: "Premium Cocktail Package",
      price: 450,
      category: "Drinks",
      sold: 89,
      rating: 4.6,
      status: "active"
    },
    {
      id: 3,
      name: "Parking Pass",
      price: 50,
      category: "Add-ons",
      sold: 234,
      rating: 4.2,
      status: "active"
    }
  ];

  return (
    <div className="space-y-6">
      <Card className="bg-white/5 border-white/20 backdrop-blur-sm">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-white flex items-center gap-2">
              <ShoppingBag className="w-5 h-5" />
              E-Commerce & Add-ons
            </CardTitle>
            <Button className="bg-white text-black hover:bg-gray-200">
              <Plus className="w-4 h-4 mr-2" />
              Add Product
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Revenue Overview */}
          <div className="grid md:grid-cols-3 gap-4">
            <Card className="bg-white/5 border-white/20">
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-green-500/20 rounded-lg">
                    <TrendingUp className="w-5 h-5 text-green-400" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">R45K</div>
                    <div className="text-gray-400 text-sm">Monthly Revenue</div>
                  </div>
                </div>
              </CardContent>
            </Card>
            
            <Card className="bg-white/5 border-white/20">
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-blue-500/20 rounded-lg">
                    <Package className="w-5 h-5 text-blue-400" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">338</div>
                    <div className="text-gray-400 text-sm">Items Sold</div>
                  </div>
                </div>
              </CardContent>
            </Card>
            
            <Card className="bg-white/5 border-white/20">
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-purple-500/20 rounded-lg">
                    <Star className="w-5 h-5 text-purple-400" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">4.5</div>
                    <div className="text-gray-400 text-sm">Avg Rating</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Product List */}
          <div className="space-y-4">
            <h3 className="text-white font-medium text-lg">Products & Services</h3>
            {products.map((product) => (
              <Card key={product.id} className="bg-white/5 border-white/20">
                <CardContent className="p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center">
                        <Package className="w-6 h-6 text-white/50" />
                      </div>
                      <div>
                        <h4 className="text-white font-medium">{product.name}</h4>
                        <div className="flex items-center gap-3 text-sm text-gray-400">
                          <span>{product.category}</span>
                          <span>•</span>
                          <span>{product.sold} sold</span>
                          <span>•</span>
                          <div className="flex items-center gap-1">
                            <Star className="w-3 h-3 text-yellow-400 fill-current" />
                            <span>{product.rating}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="text-right">
                        <div className="text-white font-bold text-lg">R{product.price}</div>
                        <Badge className="bg-green-500/20 text-green-400">{product.status}</Badge>
                      </div>
                      <div className="flex gap-2">
                        <Button size="sm" variant="outline" className="border-white text-white hover:bg-white hover:text-black">
                          Edit
                        </Button>
                        <Button size="sm" variant="outline" className="border-white text-white hover:bg-white hover:text-black">
                          View
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Add New Product */}
          <Card className="bg-white/5 border-white/20">
            <CardHeader>
              <CardTitle className="text-white text-lg">Add New Product/Service</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="text-white text-sm font-medium mb-2 block">Product Name</label>
                  <input
                    type="text"
                    placeholder="Enter product name"
                    className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white placeholder-gray-400"
                  />
                </div>
                <div>
                  <label className="text-white text-sm font-medium mb-2 block">Category</label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white">
                    <option value="drinks">Drinks & Beverages</option>
                    <option value="vip">VIP Packages</option>
                    <option value="addons">Add-ons & Services</option>
                    <option value="merchandise">Merchandise</option>
                    <option value="parking">Parking & Transport</option>
                  </select>
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="text-white text-sm font-medium mb-2 block">Price (ZAR)</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white placeholder-gray-400"
                  />
                </div>
                <div>
                  <label className="text-white text-sm font-medium mb-2 block">Quantity Available</label>
                  <input
                    type="number"
                    placeholder="Unlimited"
                    className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white placeholder-gray-400"
                  />
                </div>
              </div>
              
              <div>
                <label className="text-white text-sm font-medium mb-2 block">Description</label>
                <textarea
                  placeholder="Describe the product or service..."
                  className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white placeholder-gray-400 h-20"
                />
              </div>
              
              <Button className="bg-white text-black hover:bg-gray-200">
                <Plus className="w-4 h-4 mr-2" />
                Add Product
              </Button>
            </CardContent>
          </Card>

          {/* POS Integration */}
          <Card className="bg-white/5 border-white/20">
            <CardHeader>
              <CardTitle className="text-white text-lg">POS System Integration</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-white/5 rounded-lg">
                <div className="flex items-center gap-3">
                  <CreditCard className="w-6 h-6 text-white" />
                  <div>
                    <div className="text-white font-medium">Payment Processing</div>
                    <div className="text-gray-400 text-sm">Connect your POS system for seamless transactions</div>
                  </div>
                </div>
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-black">
                  Configure
                </Button>
              </div>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div className="p-4 bg-white/5 rounded-lg text-center">
                  <Package className="w-8 h-8 text-white/50 mx-auto mb-2" />
                  <div className="text-white font-medium">Inventory Sync</div>
                  <div className="text-gray-400 text-sm">Auto-update stock levels</div>
                </div>
                <div className="p-4 bg-white/5 rounded-lg text-center">
                  <TrendingUp className="w-8 h-8 text-white/50 mx-auto mb-2" />
                  <div className="text-white font-medium">Sales Analytics</div>
                  <div className="text-gray-400 text-sm">Real-time sales tracking</div>
                </div>
              </div>
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </div>
  );
};

export default VenueEcommerce;
